(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["couchery-cascade-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('couchery-cascade-video')) {
  customElements.define('couchery-cascade-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-cascade-configure]');
      if (!this.button || this.onConfigure) return;
      this.onConfigure = (event) => {
        const target = document.getElementById('cascade-configure');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const headerHeight = Math.max(document.querySelector('.section-header')?.getBoundingClientRect().height || 0, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0);
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 24);
        target.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.button.addEventListener('click', this.onConfigure);
    }
    disconnectedCallback() {
      if (this.button && this.onConfigure) this.button.removeEventListener('click', this.onConfigure);
      this.onConfigure = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["couchery-cloudnest-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('couchery-cloudnest-video')) {
  customElements.define('couchery-cloudnest-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-cloudnest-configure]');
      if (!this.button || this.onConfigure) return;
      this.onConfigure = (event) => {
        const target = document.getElementById('cloudnest-configure');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const headerHeight = Math.max(document.querySelector('.section-header')?.getBoundingClientRect().height || 0, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0);
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 24);
        target.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.button.addEventListener('click', this.onConfigure);
    }
    disconnectedCallback() {
      if (this.button && this.onConfigure) this.button.removeEventListener('click', this.onConfigure);
      this.onConfigure = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["couchery-driftnest-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('couchery-driftnest-video')) {
  customElements.define('couchery-driftnest-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-driftnest-configure]');
      if (!this.button || this.onConfigure) return;
      this.onConfigure = (event) => {
        const target = document.getElementById('driftnest-configure');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const headerHeight = Math.max(document.querySelector('.section-header')?.getBoundingClientRect().height || 0, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0);
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 24);
        target.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.button.addEventListener('click', this.onConfigure);
    }
    disconnectedCallback() {
      if (this.button && this.onConfigure) this.button.removeEventListener('click', this.onConfigure);
      this.onConfigure = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["couchery-lumanest-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('couchery-lumanest-video')) {
  customElements.define('couchery-lumanest-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-lumanest-configure]');
      if (!this.button || this.onConfigure) return;
      this.onConfigure = (event) => {
        const target = document.getElementById('lumanest-configure');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const headerHeight = Math.max(document.querySelector('.section-header')?.getBoundingClientRect().height || 0, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0);
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 24);
        target.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.button.addEventListener('click', this.onConfigure);
    }
    disconnectedCallback() {
      if (this.button && this.onConfigure) this.button.removeEventListener('click', this.onConfigure);
      this.onConfigure = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["couchery-luxenap-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('couchery-luxenap-video')) {
  customElements.define('couchery-luxenap-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-luxenap-configure]');
      if (!this.button || this.onConfigure) return;
      this.onConfigure = (event) => {
        const target = document.getElementById('luxenap-configure');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const headerHeight = Math.max(document.querySelector('.section-header')?.getBoundingClientRect().height || 0, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0);
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 24);
        target.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.button.addEventListener('click', this.onConfigure);
    }
    disconnectedCallback() {
      if (this.button && this.onConfigure) this.button.removeEventListener('click', this.onConfigure);
      this.onConfigure = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["couchery-mallownest-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('couchery-mallownest-video')) {
  customElements.define('couchery-mallownest-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-mallownest-configure]');
      if (!this.button || this.onConfigure) return;
      this.onConfigure = (event) => {
        const target = document.getElementById('mallownest-configure');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const headerHeight = Math.max(document.querySelector('.section-header')?.getBoundingClientRect().height || 0, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0);
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 24);
        target.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.button.addEventListener('click', this.onConfigure);
    }
    disconnectedCallback() {
      if (this.button && this.onConfigure) this.button.removeEventListener('click', this.onConfigure);
      this.onConfigure = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["couchery-serenity-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('couchery-serenity-feature')) {
  customElements.define('couchery-serenity-feature', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-serenity-configure]');
      if (!this.button || this.onConfigure) return;
      this.onConfigure = (event) => {
        const target = document.getElementById('serenity-configure');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        const headerHeight = Math.max(document.querySelector('.section-header')?.getBoundingClientRect().height || 0, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0);
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerHeight - 24);
        target.focus({ preventScroll: true });
        window.scrollTo({
          top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      this.button.addEventListener('click', this.onConfigure);
    }
    disconnectedCallback() {
      if (this.button && this.onConfigure) this.button.removeEventListener('click', this.onConfigure);
      this.onConfigure = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
